import { Typography, TypographyProps } from "@mui/material"
import { KojinResult } from "interface/kojin"

type SeibetuProps = {
	seibetuCode: KojinResult['seibetuCode']
} & TypographyProps
export const Seibetu = ({
	seibetuCode,
	...others
}: SeibetuProps) => (
	<Typography variant="caption" color="text.primary" component="div" {...others}>{
		seibetuCode === '1' ? '男性' :
		seibetuCode === '2' ? '女性' : 'その他／不明'
	}</Typography>
)